import styled from '@mui/system/styled';
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import IconButton from '@mui/material/IconButton'
import Checkbox from '@mui/material/Checkbox'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'

export const CustomeCard = styled(Card)({
    width: "100%",
    height: "340px",
    position: 'relative',
    margin: 'auto',
    '@media (min-width:768px) and (max-width:912px)': {
      maxWidth: "230px",
      width: "230px",
      height: "350px",
      position: 'relative',
      margin: 'auto'
  
    },
    '@media (min-width:913px) ': {
      maxWidth: "230px",
      width: "230px",
      height: "370px",
      position: 'relative',
      margin: 'auto'
    }
  })
export const CustomeCardMedia = styled(CardMedia)({
    width: "100% !important",
  
    height: "185px !important",
    // height: "120px!important" before,
    objectFit: " contain !important",
    "@media (min-width:280px) and (max-width:300px)": {
      height: "185px !important",
  
    },
    '@media (min-width:768px) and (max-width:912px)': {
      width: "100% !important",
  
      height: "200px !important",
      // height: "140px !important" before ,
      objectFit: " contain !important",
    },
    '@media (min-width:913px) ': {
  
  
      width: "100% !important",
  
      height: "210px !important",
      // height: "140px !important" before ,
      objectFit: " contain !important",
    }
  })
export const CustomeCardActions = styled(CardActions)(({ locale }) => ({
  
    gap: "0rem",
    justifyContent: "space-between",
    padding: "0px ",
    flexDirection: "column",
    marginLeft: "0 !important",
    marginRight: "0 !important",
    alignItems: locale == "ar" ? "flex-start" : "flex-start",
    "&.MuiCardActions-root>:not(:first-of-type)": {
      marginLeft: "0 !important",
      marginRight: "0 !important",
    },
    '@media (min-width:768px) and (max-width:912px)': {
  
      gap: "2rem",
      justifyContent: "space-around",
      padding: "0px"
      ,
      "&.MuiCardActions-root>:not(:first-of-type)": {
        marginLeft: "0 !important",
        marginRight: "0 !important",
      }
  
      ,
  
    },
    '@media (min-width:913px) ': {
  
      gap: "0rem",
      justifyContent: "space-around",
      padding: "0px 0px 16px 0px",
  
  
    },
  }))
export const CustomeCardContent = styled(CardContent)({
    padding: "10px 8px 0px 8px",
    '& .MuiTypography-root':
    {
      color: "black",
      fontSize: "0.8rem"
    },
    '@media (min-width:768px) and (max-width:912px)': {
  
      '& .MuiCardContent-root': {
  
        padding: "16px 16px 0px 16px"
  
      },
      '& .MuiTypography-root':
      {
        color: "black",
        fontSize: "0.9rem"
      },
    },
    '@media (min-width:913px) ': {
      padding: "10px 8px 0px 8px",
      '& .MuiTypography-root':
      {
        color: "black",
        fontSize: "0.9rem"
      },
    }
  
  
  })
export const CustomeCheckbox = styled(Checkbox)({
  
    // padding: " 19px 13px",
    padding: " 16px 16px",
  
  
  
  })
export const CustomeIconbtn = styled(IconButton)({
  
    "&.MuiIconButton-root:hover": {
      backgroundColor: "transparent !important"
    },
  
  
    width: "100% ",
    borderRadius: "0% !important",
  
    "@media (min-width:280px) and (max-width:300px)": {
  
    },
  
    "@media (min-width:768px) and (max-width:912px)": {
  
    },
    "@media (min-width:913px) ": {
  
    }
  });
  export const CustomeTextField = styled(TextField)({
    '& .MuiInputLabel-root': {
        fontSize: "1rem !important"
    },
    '& .MuiOutlinedInput-input': {
        fontSize: "1rem !important"
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      boxShadow: "0 0 4px #bcbcbc !important",
      border:"unset"
  },
    '@media (min-width:768px) and (max-width:912px)': {
        '& .MuiInputLabel-root': {
            fontSize: "1rem !important"
        },
        '& .MuiOutlinedInput-input': {
            fontSize: "1rem !important"
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: "0px",
          boxShadow: "none !important",
          border:"unset"
      },
    },
    '@media (min-width:913px) ': {
        '& .MuiInputLabel-root': {
            fontSize: "1rem !important"
        },
        '& .MuiOutlinedInput-input': {
            fontSize: "1rem !important"
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: "0px",
          boxShadow: "none !important",
          border:"unset"
      },
    },
})
export const CustomeFormControl = styled(FormControl)(({ type }) => ({
    width: "100%",
    margin: 0,
    '& .MuiSelect-icon': {
        color: "#008C8D ",
        display: type ? "none" : "",
    },
    '& label.Mui-focused': {
        color: "#008C8D ",
    },

    '& .MuiInputLabel-root': {
        fontSize: "1rem !important",
    },
    '& .MuiSelect-select': {
        fontSize: "1rem !important"
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      boxShadow: "0 0 4px #bcbcbc !important",
      border:"unset"
  },
    '@media only screen and  (min-width:280px){': {
        '& .MuiInputLabel-root': {
            fontSize: "1rem !important",
        },
    },
    '@media (min-width:768px) and (max-width:912px)': {
        '& .MuiInputLabel-root': {
            fontSize: "1rem !important",
        },
        '& .MuiSelect-select': {
            fontSize: "1rem !important"
        },
        width: "100%",
        "& .MuiOutlinedInput-root": {
          borderRadius: "0px",
          boxShadow: "none !important",
          border:"unset"
      },
    },
    '@media (min-width:913px) ': {
        '& .MuiInputLabel-root': {
            fontSize: "1rem !important",
        },
        '& .MuiSelect-select': {
            fontSize: "1rem !important"
        },
        width: "100%",
        "& .MuiOutlinedInput-root": {
          borderRadius: "0px",
          boxShadow: "none !important",
          border:"unset"
      },
    },
}));
export const Customeselect = styled(Select)(({ locale }) => ({
    '& .MuiSelect-select': {
        textAlign: locale == "ar" ? "left" : "left"
    },
    '& .MuiSelect-root': {
        borderRadius: "8px",
    },
}))
export const CustomeBorder = styled('div')(({ locale }) => ({
    borderRight: "none",
    '@media (min-width:768px) and (max-width:912px)': {
        borderLeft: locale == "ar" ? "1px solid #e0e0e0" : "1px solid #e0e0e0",
    },
    '@media (min-width:913px) ': {
        borderLeft: locale == "ar" ? "1px solid #e0e0e0" : "1px solid #e0e0e0",
    }
}))